module.exports = __webpack_public_path__ + "img/10.0a26d444.png";